exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?minimize!../../../assets/css/button.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-8af52844!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/user/RoleManager.vue
// module id = 604
// module chunks = 2